export enum Step {
  Flow = 'flow',
  Visitor = 'visitor',
  Escort = 'escort',
  Host = 'host',
  Date = 'date',
  Custom_Fields = 'custom_fields',
}
